import { z } from 'zod';
export const upsertSttConfigSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    provider: z.enum(['deepgram', 'azure_asr', 'azure_openai', 'google']),
    model: z.string().min(1),
    language: z.string().min(1),
    use_filler_words: z.boolean(),
    detect_language: z.boolean(),
    interim_results: z.boolean(),
    punctuate: z.boolean(),
    numerals: z.boolean(),
    smart_format: z.boolean(),
    spoken_punctuation: z.boolean(),
    profanity_filter: z.boolean(),
    enable_diarization: z.boolean(),
    explicit_punctuation: z.boolean(),
    enable_word_time_offsets: z.boolean(),
    enable_word_confidence: z.boolean(),
    enable_voice_activity_events: z.boolean(),
    energy_filter: z.boolean(),
    endpointing_ms: z.number(),
    min_confidence_threshold: z.number(),
    keyterms: z.array(z.string()),
    phrase_list: z.array(z.string()),
    prompt: z.string().nullable(),
    noise_reduction: z.string().nullable(),
    agentId: z.string(),
});
